import React from "react";
import { NumberInput, NumberInputProps } from "react-admin";
import { InputAdornment } from "@mui/material";

const CurrencyInput = (props: NumberInputProps) => (
  <NumberInput
    InputProps={{
      endAdornment: <InputAdornment position="end">€</InputAdornment>,
    }}
    {...props}
  />
);
export default CurrencyInput;
